module.exports = __webpack_public_path__ + "static/simple-doughnut-b0207ebc6e64f8fc03703500f6c47c09.png";